<div *ngIf="queueData" id="content" fxLayout="column" fxLayoutAlign="start stretch">

  <div fxLayout="column" id="container">

    <div fxLayout="column" id="agent-list" fxLayoutGap="16px">
      <h2>{{'skill_editor.agents' | translate}}:</h2>
      <div cdkDropList class="drag-drop-list" (cdkDropListDropped)="drop($event)" fxLayout="column">
        <div class="header-box">
          <div fxFlex="10" *ngIf="!hasDragAndDrop">{{'skill_editor.priority' | translate}}</div>
          <div fxFlex>{{'skill_editor.list_header_name' | translate}}</div>
          <div fxFlex="20">{{'skill_editor.list_header_active' | translate}}</div>
          <div fxFlex="20">{{'skill_editor.noreply_time' | translate}}</div>
          <div fxFlex="20">{{'skill_editor.wrap_up' | translate}}</div>
          <div fxFlex="15"></div>
        </div>
        <div [ngClass]="hasDragAndDrop ? 'drag-drop-box' : 'box'" *ngFor="let agent of queueData.queueAgents" cdkDrag [cdkDragDisabled]="!hasDragAndDrop">
          <div fxFlex="10" *ngIf="!hasDragAndDrop">
            <mat-select [(ngModel)]="agent.skillLevel" (ngModelChange)="selectChange(agent)">
              <mat-option *ngFor="let value of dropdownSkillValues" [value]="value">{{value}}</mat-option>
            </mat-select>
          </div>
          <div fxFlex fxLayout="column">
            <div class="nowrap">{{getAgentName(agent)}}</div>
            <div [ngClass]="getQueueAgentStatusColor(agent)"><mat-icon>person</mat-icon>{{getQueueStatus(agent) | translate}}</div>
          </div>
          <div fxFlex="20">
            <mat-slide-toggle class="queueSlider" [disabled]="!canEdit(agent)" *ngIf="canEditActive; else showReadOnly"
              [checked]="agent.active" (change)="toggleActive(agent)" color="primary"></mat-slide-toggle>
            <ng-template #showReadOnly>
              <mat-icon color="primary" *ngIf="agent.active" matTooltip="{{'queue.logged_in' | translate }}">person</mat-icon>
              <mat-icon color="accent" *ngIf="!agent.active" matTooltip="{{'queue.logged_out' | translate }}">person</mat-icon>
            </ng-template>
          </div>
          <div fxFlex="20">
            <mat-select *ngIf="canEdit(agent); else showValue" [(ngModel)]="agent.noReplyTime" (ngModelChange)="selectChange(agent)">
              <mat-option *ngFor="let value of noReplyTime" [value]="value">{{value | durationFormatter:'seconds':'m \[m\] s \[s\]'}}</mat-option>
            </mat-select>
            <ng-template #showValue>{{agent.noReplyTime | durationFormatter:'seconds':'m \[m\] s \[s\]'}}</ng-template>
          </div>
          <div fxFlex="20">
            <mat-select *ngIf="canEdit(agent); else showValue" [(ngModel)]="agent.wrapupTime" (selectionChange)="selectChange(agent)">
              <mat-option *ngFor="let value of wrapupTime" [value]="value">{{value | durationFormatter:'seconds':'m \[m\] s \[s\]'}}</mat-option>
            </mat-select>
            <ng-template #showValue>{{agent.wrapupTime | durationFormatter:'seconds':'m \[m\] s \[s\]'}}</ng-template>
          </div>
          <div fxFlex="15">
            <div class="action-btn-container" fxLayoutAlign="start center" *ngIf="canEdit(agent)">
              <button *ngIf="isAdmin" mat-icon-button (click)="removeAgent(agent)"
                matTooltip="{{'skill_editor.remove_agent' | translate}}" class="btn-agent-remove" color="primary">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="newAgent" [ngClass]="hasDragAndDrop ? 'drag-drop-box' : 'box'">
            <div fxFlex="10" *ngIf="!hasDragAndDrop">
              <!-- (ngModelChange)="newAgen" -->
                <mat-select [(ngModel)]="newAgent.skillLevel">
                  <mat-option *ngFor="let value of dropdownSkillValues" [value]="value">{{value}}</mat-option>
                </mat-select>
              </div>
          <gt-phone-number-selector fxFlex *ngIf="!newAgent.login" (phoneNumberSelected)="newAgentAdded($event)"
                                    [searchEndUsers]="true" [allowOtherNumber]="false" floatLabel="never"
                                    [excludeAgentList]="queueData.queueAgents">
          </gt-phone-number-selector>
          <span fxFlex class="mat-content cursorDefault" *ngIf="newAgent.login">
            {{ getAgentName(newAgent) }}
          </span>
          <div fxFlex="15" fxLayout="row" fxLayoutAlign="start center" class="action-btn-container">
            <button mat-icon-button (click)="newAgent = null"
              matTooltip="{{'global.cancel' | translate}}" color="primary">
              <mat-icon>cancel</mat-icon>
            </button>
            <button mat-icon-button (click)="saveNewAgent(newAgent)" id="btn-save-agent" [disabled]="!newAgent.login"
              matTooltip="{{'global.save' | translate}}" color="primary">
              <mat-icon>save</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div style="margin-top: 16px;">
        <button mat-button id="btn-add-agent" color="primary" (click)="initNewAgent()" *ngIf="isAdmin && !newAgent">
          <mat-icon>add</mat-icon>
          {{'skill_editor.add_new' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>


      <!-- this is the summary, in case we want it back
         <div class="content" fxLayout="column" fxLayoutGap="16px" id="summary" fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="space-around center">
            <h2>
              {{queueData.agentsAvailable}} / {{queueData.queueAgents.length}}
            </h2>
            <strong class="color-gray">
              {{'skill_editor.available' | translate}}
            </strong>
          </div>

          <div fxLayout="column" fxLayoutAlign="center center">
            <h2>
              {{queueData.calls}}
            </h2>
            <strong class="color-gray">
              {{'skill_editor.in_queue' | translate}}
            </strong>
          </div>

          <div fxLayout="column" fxLayoutAlign="center center">
            <h2>
              {{queueData.maxTime | durationFormatter}}
            </h2>
            <strong class="color-gray">
              {{'skill_editor.waiting_time' | translate}}
            </strong>
          </div>

        </div> -->




<!--  this is not part of the design
  <div *ngIf="selectedAgent">
  <div id="agent-settings">
    <h2>{{'skill_editor.settings_title' | translate:{name: getAgentName(selectedAgent)} }}</h2>
    <h4>{{'skill_editor.noreply_time' | translate}}</h4>
    <div>
      <mat-slider [max]="60" [min]="0" [step]="1" [thumbLabel]="true" [(ngModel)]="selectedAgent.noReplyTime"
        (ngModelChange)="agentChanged = true">
      </mat-slider>
      <h1 class="settingsNumber">{{selectedAgent.noReplyTime}}s</h1>
    </div>
    <h4>{{'skill_editor.wrap_up' | translate}}</h4>
    <div>
      <mat-slider [max]="60" [min]="0" [step]="1" [thumbLabel]="true" [(ngModel)]="selectedAgent.wrapupTime"
        (ngModelChange)="agentChanged = true">
      </mat-slider>
      <h1 class="settingsNumber">{{selectedAgent.wrapupTime}}s</h1>
    </div>
  </div>
  <div align="center" style="margin-top: 16px;">
    <button mat-button id="btn-reset" color="primary" (click)="resetAgentSettings(selectedAgent)" *ngIf="selectedAgent">
      {{'global.reset' | translate}}
    </button>
    <button mat-button id="btn-close" color="primary" (click)="goBack()">{{'global.back' | translate}}</button>
  </div>
</div> -->
